export * from "./occlusionMaterial.js";
//# sourceMappingURL=index.js.map